<template>
  <v-row class="background-white mx-0">
    <!-- Header -->
    <v-col cols="12" :class="$vuetify.display.xs ? 'text-center pl-0' : ''">
      <!-- My Debt Stacking Plan -->
      <p
        class="debtStackingPlanText font-weight-bold"
        :class="$vuetify.display.xs ? 'text-center pl-0' : ''"
      >
        {{ $t('L_my_debt_stacking_plan') }}
      </p>
      <!-- IMPORTANT ASSUMPTIONS AND DISCLOSURES -->
      <a
        href="javascript:void(0)"
        class="importantAssumptionText font-weight-bold text-decoration-none"
        :class="$vuetify.display.xs ? 'text-center' : 'paddingImportantAssumptions'"
        @click="openImportantDisclosures"
      >
        {{ $t('L_important_assumption_and_disclosure') }}
      </a>
    </v-col>

    <!-- Sliders and arrow -->
    <v-col cols="12">
      <!--Start Top Row with Date and # of debts remaining -->
      <v-row
        align-content="center"
        justify="start"
        class="lightGrayBorderBottom lightGrayBorderTop text-center"
      >
        <!-- left arrow - active -->
        <v-col
          v-if="slideIndex > 0"
          cols="auto"
          @click="goLeft"
          class="font-text-bold SpacingForColumnHeader leftArrow"
          align-self="center"
        >
          <v-img alt="active left arrow" class="leftArrow" src="../assets//LeftActive.svg" />
        </v-col>
        <!-- left arrow - inactive -->
        <v-col
          v-else
          cols="auto"
          @click="goLeft"
          class="font-text-bold SpacingForColumnHeader leftArrow"
          align-self="center"
        >
          <v-img alt="inactive left arrow" class="leftArrow" src="../assets/LeftInactive.svg" />
        </v-col>

        <v-col cols="auto" class="bottomLayer marginAuto">
          <!-- <div> -->
          <!-- column 1 -->
          <div
            v-if="showColumn1"
            class="SpacingForColumnHeader lightGrayBorderLeftRight higherLayerThanLeftRightArrow dataColumnMaxWidth"
            :class="firstDataColumn ? 'haveBlueBackground' : 'showWhiteBackground'"
          >
            <div>{{ addAMonth(slideIndex) }}</div>
            <div class="debtsRemaining">
              {{ numOfDebtsRemaining(slideIndex) }}
            </div>
          </div>
          <!-- column 2 -->
          <div
            v-if="showColumn2"
            class="SpacingForColumnHeader lightGrayBorderLeftRight dataColumnMaxWidth"
            :class="secondDataColumn ? 'haveBlueBackground' : 'showWhiteBackground'"
          >
            <div>{{ addAMonth(slideIndex + 1) }}</div>
            <div class="debtsRemaining">
              {{ numOfDebtsRemaining(slideIndex + 1) }}
            </div>
          </div>
          <!-- column 3 -->
          <div
            v-if="showColumn3"
            class="SpacingForColumnHeader lightGrayBorderLeftRight dataColumnMaxWidth"
            :class="thirdDataColumn ? 'haveBlueBackground' : 'showWhiteBackground'"
          >
            <div>{{ addAMonth(slideIndex + 2) }}</div>
            <div class="debtsRemaining">
              <span>
                <!-- v-if="getAge(getMonthYearForTodayAgeCalculation(slideIndex+2)) !== ''" -->
                {{ numOfDebtsRemaining(slideIndex + 2) }}
              </span>
            </div>
          </div>
          <!-- </div> -->
        </v-col>

        <!-- right arrow - active -->
        <v-col
          v-if="canGoRight"
          cols="auto"
          @click="goRight"
          class="font-text-bold SpacingForColumnHeader rightArrow"
          align-self="center"
        >
          <v-img alt="active right arrow" class="rightArrow" src="../assets/RightActive.svg" />
        </v-col>
        <!-- right arrow - inactive -->
        <v-col
          v-else
          cols="auto"
          class="font-text-bold SpacingForColumnHeader rightArrow"
          align-self="center"
        >
          <v-img alt="inactive right arrow" class="rightArrow" src="../assets/RightInactive.svg" />
        </v-col>
        <div>
          <div :class="canGoRight ? 'seeMorePayOff' : 'seeMorePayOffHidden'" class="mt-4">
            <span v-if="canGoRight" class="seeMorePayOffDates">{{
              $t('L_see_more_pay_off_dates')
            }}</span>
          </div>
        </div>
      </v-row>
    </v-col>

    <!--Column for each Debt List-->
    <v-col>
      <v-row
        class="pt-2"
        :class="showColumn4 && !canGoRight ? 'columnFourMargin' : 'columnFourMarginTwo'"
      >
        <div class="marginAuto" :class="!showColumn4 ? 'columnFourHideMargin' : ''">
          <v-col v-if="showColumn1" class="dataColumnMaxWidth">
            <DebtStackColumn :debt-data="hideDataBeforeIndex(slideIndex)" />
          </v-col>
          <v-col v-if="showColumn2" class="dataColumnMaxWidth">
            <DebtStackColumn :debt-data="hideDataBeforeIndex(slideIndex + 1)" />
          </v-col>
          <v-col
            v-if="showColumn3"
            class="dataColumnMaxWidth"
            :class="canGoRight ? '' : 'zpositionAbsolute'"
          >
            <DebtStackColumn :debt-data="hideDataBeforeIndex(slideIndex + 2)" />
          </v-col>
          <v-col v-if="showColumn4" class="hiddenData dataColumnMinWidth">
            <DebtStackColumn
              :debt-data="hideDataBeforeIndex(slideIndex + 3)"
              :right-most-col="true"
            />
          </v-col>
        </div>
      </v-row>
    </v-col>

    <!-- Monthly Payment... -->
    <v-col cols="12" class="text-center">
      <p class="monthlyPayment">
        {{ $t('L_monthly_payment') }}
      </p>
      <p class="pt-4 pb-4">
        <span class="text-body-2 pillButtonTotalDebtPayment">{{ totalDebtPayment }}</span>
      </p>
      <p class="thisAmountDoesNotChange text-caption">
        {{ $t('L_this_amount_doesnot_change') }}
      </p>
    </v-col>

    <!-- Assumes 8% rate of return... if="paidOffDebts.length > 0" -->
    <v-col
      v-if="paidOffDebts.length > 0"
      cols="12"
      class="max-width-assume-section text-center text-caption"
    >
      {{ $t('L_assumes_eight_percent_rate_of_return_this_illustration') }}
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { openInNewWindow } from '@/mixins/openNewWindow';
import DebtStackColumn from './MyPlanDebtStackingPlanDebtStackColumn.vue';
import { mapState } from 'pinia';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import { addMonths, differenceInYears, format } from 'date-fns';
import { mdiChevronLeft } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'DebtStackingPlan',
  components: {
    DebtStackColumn,
  },
  data: () => ({
    // TODO replace this will the age of the person
    dob: '4/1/1990',
    slideIndex: 0,
    debtData: [],
    mdiChevronLeft,
  }),
  mixins: [openInNewWindow],
  computed: {
    ...mapState(useDebtSolutionsStore, {
      hasActivePlan: 'hasActivePlan',
      hasNoPlan: 'hasNoPlan',
      debts: 'debts',
      unpaidDebts: 'unpaidDebts',
      paidOffDebts: 'paidOffDebts',
      getTotalMinPaymentUsinggPaidOffDebts: 'getTotalMinPaymentUsinggPaidOffDebts',
      debtGivenDebtId: 'debtGivenDebtId',
      planWStacking: 'planWStacking',
      twoOrMoreDebtsAndMinOneUnpaidDebt: 'twoOrMoreDebtsAndMinOneUnpaidDebt',
      personInfo: 'personInfo',
    }),
    firstDataColumn() {
      return (
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length > 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 1) ||
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length === 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 0)
      );
    },
    secondDataColumn() {
      return (
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length > 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 2) ||
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length === 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 1)
      );
    },
    thirdDataColumn() {
      return (
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length > 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 3) ||
        (this.planWStacking?.planItemCollection?.length >= 1 &&
          this.paidOffDebts?.length === 0 &&
          this.slideIndex === this.planWStacking?.planItemCollection?.length - 2)
      );
    },
    getColumnWidth() {
      if (this.$vuetify.display.width > 780) {
        return 'xs-3';
      } else if (this.$vuetify.display.width > 550) {
        return 'xs-5';
      }
      return 'xs-10';
    },
    showColumn1() {
      return true;
    },
    showColumn2() {
      if (this.$vuetify.display.width >= 660) {
        return true;
      }
      return false;
    },
    showColumn3() {
      if (
        /* (this.$vuetify.display.width >= 925 && this.$vuetify.display.width < 960) || */
        this.$vuetify.display.width >= 1024
      ) {
        return true;
      }
      return false;
    },
    showColumn4() {
      if (this.$vuetify.display.width >= 1024) {
        return true;
      }
      return false;
    },
    canGoRight() {
      if (this.planWStacking?.planItemCollection === undefined && this.paidOffDebts === undefined) {
        return false;
      } else if (
        this.planWStacking?.planItemCollection?.length >= 1 &&
        this.paidOffDebts?.length > 0
      ) {
        return this.slideIndex < this.planWStacking?.planItemCollection?.length - 3; // Need to change to -1?
      } else if (
        (this.showColumn3 &&
          this.slideIndex < this.planWStacking?.planItemCollection?.length - 2) ||
        (this.showColumn2 &&
          !this.showColumn3 &&
          this.slideIndex < this.planWStacking?.planItemCollection?.length - 1) ||
        (this.showColumn1 &&
          !this.showColumn2 &&
          !this.showColumn3 &&
          this.slideIndex < this.planWStacking?.planItemCollection?.length)
      ) {
        return true;
      }
      return false;
    },
    checkIfDebtPaidOffOnScreen() {
      if (this.planWStacking?.planItemCollection === undefined) {
        return false;
      } else if (this.slideIndex > this.planWStacking?.planItemCollection?.length - 2) {
        return true;
      }
      return false;
    },
    totalDebtPayment() {
      return this.$n(this.planWStacking?.planTotals?.newPayment, 'currency', 'en-US');
    },
  },
  mounted() {
    const tDate = new Date(this?.personInfo?.dob);
    const rDate = format(tDate, 'MM/dd/yyyy');
    this.dob = rDate;
  },
  methods: {
    hideDataBeforeIndex(idx: number) {
      let tDebtData = this.planWStacking.planItemCollection;

      if (tDebtData !== undefined) {
        tDebtData = JSON.parse(JSON.stringify(tDebtData));

        // isAcceleratedDebt set if at least one paidOffDebts and is the 1st item
        if (tDebtData.length >= 2 && this.paidOffDebts.length > 0 && idx === 0) {
          tDebtData[0].isBlueBoxTop = true;
          tDebtData[1].isBlueBoxBottom = true;
        } else if (tDebtData.length >= 2 && idx === 0) {
          tDebtData[0].isBlueBoxTop = true;
          tDebtData[1].isBlueBoxBottom = false;
        } else if (this.paidOffDebts.length > 0) {
          tDebtData[0].isBlueBoxTop = false;
        }
        if (tDebtData.length >= 1 && this.paidOffDebts.length > 0) {
          tDebtData[0].isAcceleratedDebt = true;
        } else if (tDebtData.length >= 1 && this.paidOffDebts.length === 0) {
          tDebtData[0].isAcceleratedDebt = false;
        }

        // Only start hiding starting from index = 1 i.e 2 column since we start at 0
        // Setting the hideData
        for (let i = 0; i < tDebtData.length; i++) {
          // Accelerated Debt
          if (this.paidOffDebts.length > 0) {
            // Showing dashes with number at end
            if (idx === i) {
              tDebtData[i].showOnlyMonthlyAmount = true;
            } else {
              tDebtData[i].showOnlyMonthlyAmount = false;
            }
            // Show the Pay Off Date
            if (idx + 1 === i) {
              tDebtData[i].showPayOffDate = true;
            } else {
              tDebtData[i].showPayOffDate = false;
            }
            // Hiding the entire data
            if (i < idx) {
              tDebtData[i].hideData = true;
            } else {
              tDebtData[i].hideData = false;
            }
          } else {
            // First Debt
            // Showing dashes with number at end
            if (idx > 0 && idx === i + 1) {
              tDebtData[i].showOnlyMonthlyAmount = true;
            } else {
              tDebtData[i].showOnlyMonthlyAmount = false;
            }
            // Show the Pay Off Date
            if (idx === i) {
              tDebtData[i].showPayOffDate = true;
            } else {
              tDebtData[i].showPayOffDate = false;
            }
            // Hiding the entire data
            if (i + 1 < idx) {
              tDebtData[i].hideData = true;
            } else {
              tDebtData[i].hideData = false;
            }
          }
          if (i === tDebtData.length - 1) {
            tDebtData[i].islastDebt = true;
          }
        }

        // Adding data for items not in planItemCollection
        tDebtData.dontStopThereIndividualAmount =
          this.planWStacking.planTotals.dontStopThereIndividualAmount;
        return tDebtData;
      }
      return tDebtData;
    },
    async openImportantDisclosures() {
      await this.openInNewWindow({
        url: `${window.appConfig.content_stack}/blt676ecb292039a611/MISC-006.pdf`,
        target: '_blank',
      });
    },
    numOfDebtsRemaining(idx: number) {
      let debtRemaining = -1;
      if (this.planWStacking.planItemCollection === undefined) {
        debtRemaining = -1;
      } else if (this.paidOffDebts.length > 0) {
        debtRemaining = this.planWStacking.planItemCollection.length - idx - 1;
      } else if (this.planWStacking.planItemCollection.length - idx > 0) {
        debtRemaining = this.planWStacking.planItemCollection.length - idx;
      }
      if (debtRemaining <= 0 && idx <= this.unpaidDebts.length + this.paidOffDebts.length) {
        return `${this.$t('L_wow_zero_debts_remaining')}`;
      } else if (debtRemaining <= 0) {
        return '';
      } else if (debtRemaining === 1) {
        return `${this.$t('L_one_debt_remaining')}`;
      }
      return `${debtRemaining} ${this.$t('L_debts_remaining')}`;
    },
    addAMonth(idx: number) {
      let rDate = null;
      const tDebtData = this.planWStacking.planItemCollection;
      if (tDebtData === undefined) {
        return '';
      } else if (idx === 0) {
        return this.$t('L_today');
      } else if (idx <= tDebtData.length - 1 && this.paidOffDebts.length > 0) {
        const tObj = tDebtData[idx].projectedPayoffDate;
        // We need to add a month to the pay off date
        const tDate = addMonths(tObj, 1);
        rDate = format(tDate, 'MM/yyyy');
        return rDate;
      } else if (idx <= tDebtData.length && this.paidOffDebts.length === 0) {
        const tObj = tDebtData[idx - 1].projectedPayoffDate;
        // We need to add a month to the pay off date
        const tDate = addMonths(tObj, 1);
        rDate = format(tDate, 'MM/yyyy');
        return rDate;
      }
      return rDate;
    },
    getMonthYearForTodayAgeCalculation(idx: number) {
      let rDate = null;
      const tDebtData = this.planWStacking.planItemCollection;
      if (tDebtData === undefined) {
        return '';
      } else if (idx === 0) {
        return -1; /*
        const tObj = this.personInfo.dob;
        // We need to add a month to the pay off date
        const tDate = moment(tObj, 'yyyy-MM-ddTHH:mm:ss-nn:00');
        rDate = moment(tDate).format('MM/yyyy');
        return rDate; */
      } else if (idx <= tDebtData.length - 1) {
        const tObj = tDebtData[idx - 1].projectedPayoffDate;
        // We need to add a month to the pay off date
        const tDate = addMonths(tObj, 1);
        rDate = format(tDate, 'MM/yyyy');
        return rDate;
      } else if (idx <= tDebtData.length && this.paidOffDebts.length === 0) {
        // This is to handle all debts w/o any being paid off
        const tObj = tDebtData[idx - 1].projectedPayoffDate;
        // We need to add a month to the pay off date
        const tDate = addMonths(tObj, 1);
        rDate = format(tDate, 'MM/yyyy');
        return rDate;
      }
      return rDate;
    },
    goRight() {
      if (
        this.planWStacking.planItemCollection !== undefined &&
        this.slideIndex < this.planWStacking.planItemCollection.length
      ) {
        // - 2
        this.slideIndex += 1;
      }
    },
    goLeft() {
      if (this.slideIndex > 0) {
        this.slideIndex -= 1;
      }
    },
    // returns data starting from the given index to end
    getDataStartingFromGiven(index: number) {
      return this.planWStacking.planItemCollection.slice(index);
    },
    getAge(dateString: string | number) {
      if (!dateString || dateString === '') {
        return '';
      } else if (dateString === -1) {
        const tDobData = this.personInfo.dob;
        return differenceInYears(new Date(), tDobData);
      }
      const tDob = this.personInfo.dob;
      if (tDob != null || tDob !== undefined) {
        const dateObj = new Date(dateString);
        const bornObj = new Date(tDob);
        const diff = differenceInYears(dateObj, bornObj);
        return diff;
      }

      return '';
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.background-white {
  background-color: #ffffff;
}
.font-text-bold {
  font-weight: 600;
}
.hiddenData {
  opacity: 0.3;
}
.debtStackingPlanText {
  font-size: 24px;
  font-weight: 600;
  padding-left: 50px;
  padding-top: 20px;
}
.importantAssumptionText {
  padding-top: 0px;
  color: #02579e;
  font-size: 14px;
  font-weight: 600;
}
.yearsOld {
  font-size: 12px;
  color: #333333;
  margin-top: -6px;
}
.lightGrayBorderLeftRight {
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
}
.SpacingForColumnHeader {
  height: 50px;
  background-color: white;
  z-index: 1;
}
.lightGrayBorderBottom {
  border-bottom: 1px solid #d4d4d4;
}
.lightGrayBorderTop {
  border-top: 1px solid #d4d4d4;
}
.debtsRemaining {
  font-size: 10px;
  color: #333333;
}
.yearsOldVal {
  font-size: 24px;
}
.todayColor {
  color: #333333;
}
.higherLayerThanLeftRightArrow {
  z-index: 1;
  background-color: white;
}
.spaceBelowYearsOldText {
  margin-bottom: 40px;
}
.monthlyPayment {
  font-size: 16px;
  color: #333333;
}
.thisAmountDoesNotChange {
  font-size: 12px;
  color: #333333;
}
.pillButtonTotalDebtPayment {
  border-radius: 16px;
  border: 1px solid #063562;
  color: #333333;
  font-size: 18px;
  padding: 5px 10px 5px 10px;
}
.showWhiteBackground {
  background-color: white;
}
.haveBlueBackground {
  background-color: #f5faff;
}
.spacingAroundMonthlyPayment {
  margin-top: 20px;
  margin-bottom: 30px;
}
.line-on-top {
  border-top: 1px solid #e7edf4;
  padding-top: 25px;
}
.font-size-twelve {
  font-size: 12px;
}
.max-width-assume-section {
  max-width: 84%;
  margin: auto;
  padding-bottom: 25px;
}
.dataColumnMaxWidth {
  max-width: 280px;
  width: 280px;
  display: inline-block;
}
.dataColumnMinWidth {
  max-width: 24px;
  width: 24px;
  display: inline-block;
}
.arrowWidth {
  width: 45px;
  max-width: 45px;
}
.marginAuto {
  margin: auto;
}
.leftArrow {
  height: 86px !important;
  margin: -1px 0 0 0;
  position: absolute;
  left: 0;
  z-index: 2;
  width: 112px !important;
}
.leftArrowImage {
  margin-top: -12px;
  height: 86px;
  width: 112px;
}
.rightArrow {
  height: 64px !important;
  position: absolute;
  right: 0;
  z-index: 2;
  margin-top: -3px;
  width: 114px !important;
}
.positionAbsolute {
  position: absolute;
}
.bottomLayer {
  z-index: 1;
}
.seeMorePayOff {
  font-size: 10px;
  text-align: center;
  width: 44px;
  position: absolute;
  margin-left: -84px;
  z-index: 22;
  color: #063562;
  margin-top: 0px;
  background-color: #fff;
  height: 50px;
}
.seeMorePayOffHidden {
  font-size: 10px;
  text-align: center;
  width: 44px;
  position: absolute;
  margin-left: -84px;
  z-index: 22;
  color: #063562;
  margin-top: 0px;
  background-color: #f5faff;
  height: 50px;
}
.columnFourYouDidIt {
  margin-left: -255px;
}
.columnFourMargin {
  margin-left: 25px;
}
.columnFourMarginTwo {
  margin-left: 25px;
}
.columnFourHideMargin {
  padding-right: 25px;
}
.seeMorePayOffDates {
  font-size: 8px;
  font-weight: 600;
}
.paddingImportantAssumptions {
  padding-left: 50px;
}
</style>
